// src/pages/payment/PayOSCallback.tsx
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { http } from "../../services/http";
import { useCart } from "../../contexts/CartProvider";

type AnyCart = {
  clear?: () => Promise<void> | void;
};

function getQuery(search: string) {
  const q = new URLSearchParams(search);
  const orderId = q.get("orderId") || q.get("orderCode") || "";
  const cancel = q.get("cancel") === "true";
  const success = q.get("success") === "true";
  return { orderId, cancel, success };
}

export default function PayOSCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const cart = useCart() as unknown as AnyCart;

  const ran = useRef(false);
  const [statusText, setStatusText] = useState("Đang xử lý thanh toán...");

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const { orderId, cancel, success } = getQuery(location.search);

    if (!orderId) {
      setStatusText("Thiếu mã đơn hàng. Quay về giỏ hàng...");
      setTimeout(() => navigate("/cart", { replace: true }), 600);
      return;
    }

    (async () => {
      try {
        // 1) User huỷ thanh toán
        if (cancel) {
          setStatusText("Bạn đã huỷ thanh toán. Đang huỷ đơn...");
          await http.post(`/api/Order/cancel/${encodeURIComponent(orderId)}`);
          setStatusText("Đã huỷ đơn. Quay về giỏ hàng...");
          setTimeout(() => navigate("/cart", { replace: true }), 700);
          return;
        }

        // 2) Thanh toán thành công
        if (success) {
          setStatusText("Thanh toán thành công. Đang cập nhật đơn...");

          // (Tuỳ backend của bạn)
          // Nếu backend có endpoint confirm/update trạng thái payment:
          // await http.post(`/api/Order/confirm-payos/${encodeURIComponent(orderId)}`);

          // Clear cart chỉ khi success ✅
          await cart.clear?.();

          setStatusText("Hoàn tất. Đang chuyển tới đơn hàng...");
          setTimeout(
            () => navigate(`/orders/${encodeURIComponent(orderId)}`, { replace: true }),
            700
          );
          return;
        }

        // 3) Không rõ trạng thái: fallback
        setStatusText("Không xác định trạng thái. Quay về giỏ hàng...");
        setTimeout(() => navigate("/cart", { replace: true }), 700);
      } catch (e) {
        setStatusText("Có lỗi khi xử lý. Quay về giỏ hàng...");
        setTimeout(() => navigate("/cart", { replace: true }), 900);
      }
    })();
  }, [location.search, navigate, cart]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f6f3ef] px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-6 text-center">
        <div className="text-xs tracking-[0.25em] uppercase text-neutral-500">
          OWL DREAM
        </div>
        <h1 className="text-xl font-semibold mt-3">Payment Callback</h1>
        <p className="text-sm text-neutral-600 mt-2">{statusText}</p>

        <div className="mt-6 h-2 w-full rounded-full bg-neutral-100 overflow-hidden">
          <div className="h-full w-2/3 bg-black/80 animate-pulse" />
        </div>
      </div>
    </div>
  );
}
